export default "__VITE_ASSET__59b01142__"